"use client";

import { useState } from "react";
import { useForgotPassword } from "@/hooks/use-auth";
import Link from "next/link";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const forgot = useForgotPassword();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    forgot.mutate(
      { email },
      { onSuccess: () => setSubmitted(true) },
    );
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-zinc-100 to-zinc-200">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-extrabold tracking-tight text-zinc-900">Reset Password</h1>
          <p className="mt-1 text-sm text-zinc-500">
            Enter your email and we&apos;ll send you a reset link
          </p>
        </div>

        {submitted ? (
          <div className="space-y-4">
            <div className="rounded-md bg-green-50 px-4 py-3 text-sm font-medium text-green-800">
              If an account exists for <span className="font-semibold">{email}</span>, a
              password reset link has been sent. Check your inbox (and spam folder).
            </div>
            <Link
              href="/login"
              className="block text-center text-sm font-medium text-indigo-600 hover:text-indigo-800 transition"
            >
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="mb-1 block text-xs font-semibold text-zinc-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="email"
                className="w-full rounded-lg border border-zinc-300 px-3 py-2 text-sm text-zinc-900 outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                placeholder="you@example.com"
              />
            </div>

            {forgot.isError && (
              <div className="rounded-md bg-red-50 px-3 py-2 text-xs font-medium text-red-700">
                {forgot.error.message}
              </div>
            )}

            <button
              type="submit"
              disabled={forgot.isPending}
              className="w-full rounded-lg bg-indigo-600 py-2.5 text-sm font-bold text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {forgot.isPending ? "Sending..." : "Send Reset Link"}
            </button>

            <Link
              href="/login"
              className="block text-center text-sm font-medium text-zinc-500 hover:text-zinc-700 transition"
            >
              Back to Sign In
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
